import * as Yup from 'yup';
import { VALID_EMAIL_REGEX } from '../../../../core/constants/constants';

export const BILLING_DETAILS_FORM_INITIAL_VALUES = {
  name: '',
  email: '',
  address_line1: '',
  address_line2: '',
  country: null,
  state: null,
  city: '',
  postal_code: ''
};

export const validationSchema = Yup.lazy((currentValue: any) =>
  Yup.object({
    address_line1: Yup.string().trim().required(),
    city: Yup.string().trim().required(),
    country: Yup.object().required(),
    email: Yup.string().email().matches(VALID_EMAIL_REGEX).required(),
    name: Yup.string().trim().required(),
    postal_code: Yup.string().trim().required(),
    state: currentValue?.countryHasStates ? Yup.object().required() : Yup.object().nullable()
  })
);

export const buildBillingDetailsParams = (data: any): any => ({
  name: data.name,
  address_line1: data.address_line1,
  address_line2: data.address_line2,
  city: data.city,
  state: data.state ? data.state.name : '-1',
  country: data.country.code,
  postal_code: data.postal_code,
  email: data.email
});
